import { render, staticRenderFns } from "./BusCommonMessageWhiteIpModal.vue?vue&type=template&id=1c4d2a31&"
import script from "./BusCommonMessageWhiteIpModal.vue?vue&type=script&lang=js&"
export * from "./BusCommonMessageWhiteIpModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports